// Reglas puras de «Mi visita» (sin navegador): momento del día, actividades lejos del resto y qué horario proponer.
import type { ItinerarioItem } from "./itinerario";

export type Momento = "manana" | "tarde" | "noche";
const DIA = 86_400_000;
export const minutos = (hora: string) => { const [h, m] = hora.split(":").map(Number); return (h || 0) * 60 + (m || 0); };
export const momentoDe = (hora: string): Momento => (minutos(hora) < 12 * 60 ? "manana" : minutos(hora) < 18 * 60 ? "tarde" : "noche");
export const diasEntre = (a: string, b: string) => Math.round(Math.abs(Date.parse(`${a}T12:00:00Z`) - Date.parse(`${b}T12:00:00Z`)) / DIA);
export const traslapa = (a: Pick<ItinerarioItem, "fecha" | "hora" | "duracion">, b: Pick<ItinerarioItem, "fecha" | "hora" | "duracion">) =>
  a.fecha === b.fecha && minutos(a.hora) < minutos(b.hora) + Math.max(b.duracion, 30) && minutos(b.hora) < minutos(a.hora) + Math.max(a.duracion, 30);

/** Slug del tour a partir del id con que «Mi visita» lo guarda (tour-<slug>-<fecha>-<hora>). */
export const slugDeItem = (i: Pick<ItinerarioItem, "id" | "tipo">) => (i.tipo === "tour" ? /^tour-(.+)-\d{4}-\d{2}-\d{2}-\d{2}:\d{2}$/.exec(i.id)?.[1] ?? null : null);
export const idTour = (slug: string, fecha: string, hora: string) => `tour-${slug}-${fecha}-${hora}`;

/** Día con más actividades (el «centro» de la visita). Empate: el más temprano. Las cabañas no cuentan: duran varias noches. */
export function diaPrincipal(items: ItinerarioItem[]): string | null {
  const cuenta = new Map<string, number>();
  for (const i of items) if (i.tipo !== "cabana") cuenta.set(i.fecha, (cuenta.get(i.fecha) ?? 0) + 1);
  return [...cuenta.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))[0]?.[0] ?? null;
}

/** Actividades que quedaron a 2 días o más del día principal (probable despiste al elegir fecha). */
export function lejanas(items: ItinerarioItem[], descartadas: Set<string> = new Set()) {
  const centro = diaPrincipal(items);
  if (!centro) return [];
  return items.filter((i) => i.tipo !== "cabana" && i.estado !== "solicitada" && !descartadas.has(`${i.id}@${i.fecha}`) && diasEntre(i.fecha, centro) >= 2)
    .map((i) => ({ item: i, centro, dias: diasEntre(i.fecha, centro) }));
}

/** Primer horario de ese día con lugar para el grupo que no se encima con lo ya planeado. Prefiere el mismo momento del día. */
export function proponerHora(salidas: { hora: string; libres: number }[], ocupado: ItinerarioItem[], item: Pick<ItinerarioItem, "hora" | "duracion" | "personas" | "fecha">, fecha: string) {
  const libres = salidas.filter((s) => s.libres >= item.personas && !ocupado.some((o) => traslapa({ fecha, hora: s.hora, duracion: item.duracion }, o)));
  const mismo = libres.filter((s) => momentoDe(s.hora) === momentoDe(item.hora));
  return (mismo[0] ?? libres[0])?.hora ?? null;
}
